<!-- Add External Coordinator -->

<app-admin-header
  [header]="header"
  [links]="links"
  [breadcrumbs]="breadcrumbs"
  [stats]="stats"
></app-admin-header>
<div class="container custom-bg-1 my-5">
  <app-add-external-user
    [type]="'CREATE'"
    [ExternalType]="'Coordinator'"
  ></app-add-external-user>
</div>
<app-footer></app-footer>
